var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "53px",
    viewBox: "0 0 64 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7D061702-8766-4C39-822E-3F1C8991F94A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.-what-can-help",
    transform: "translate(-886.000000, -386.000000)",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(888.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.70453,26.554995 C42.80643,37.078995 33.60273,45.063645 22.53138,45.063645 C10.08738,45.063645 3e-05,34.975695 3e-05,22.531395 C3e-05,10.087845 10.08738,4.5e-05 22.53138,4.5e-05 C33.57918,4.5e-05 42.77148,7.953045 44.69223,18.448395",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.73873,26.511345 C34.03398,32.127195 28.81818,36.212745 22.64643,36.212745 C15.08928,36.212745 8.96418,30.087945 8.96418,22.531395 C8.96418,14.974695 15.08838,8.848995 22.64643,8.848995 C28.78173,8.848995 33.97218,12.887895 35.70903,18.453195",
    id: "Stroke-3",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.59422,26.47311 C25.58592,27.48231 24.19197,28.10796 22.65252,28.10796 C19.57302,28.10796 17.07672,25.61031 17.07672,22.53141 C17.07672,19.45236 19.57302,16.95561 22.65252,16.95561 C24.13227,16.95561 25.47702,17.53206 26.47482,18.47196",
    id: "Stroke-5",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.74615,
    y1: 22.466475,
    x2: 56.304,
    y2: 22.466475,
    id: "Stroke-7",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.30397,
    y1: 22.466475,
    x2: 60.46782,
    y2: 17.290125,
    id: "Stroke-9",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.46785,
    y1: 27.625215,
    x2: 56.304,
    y2: 22.449465,
    id: "Stroke-11",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.46845,
    y1: 22.466475,
    x2: 52.6323,
    y2: 17.290125,
    id: "Stroke-13",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.63233,
    y1: 27.625215,
    x2: 48.46848,
    y2: 22.449465,
    id: "Stroke-15",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-17",
    stroke: "#222456",
    points: "12.555975 42.748845 8.484675 49.553295 2.795775 49.553295 6.420675 43.585395"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-19",
    stroke: "#222456",
    points: "36.76266 40.3506 42.29136 49.5534 36.60246 49.5534 34.69896 46.3185"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBoard);
export default __webpack_public_path__ + "static/media/arrowBoard.329e0961.svg";
export { ForwardRef as ReactComponent };